export default __webpack_public_path__ + "static/media/screen_dropbox_2.7ce52829.png";